"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import "../../../foundation/iconography/ExtraIconsProvider.js";
import "../../../foundation/iconography/IconVariantProvider.js";
import "../../../foundation/iconography/icons.js";
import { Icon } from "../../../foundation/iconography/Icon.js";
import { atoms } from "@gnist/themes/atoms.css.js";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import classNames from "classnames";
import { forwardRef } from "react";
import { InputHelperText } from "../../../building-blocks/inputs/InputHelperText.js";
import "../../../utilities/layout/Row.js";
import "@gnist/themes/tokens.css.js";
import "react-content-loader";
import { iconButtonOverlayRecipe } from "../shared-styles/iconButtonOverlay.css.js";
import { inputFieldWrapperRecipe, inputFieldStyle, inputContentWrapper, wrapperStyle } from "../shared-styles/inputField.css.js";
import { postInputWidth, preInputWidth } from "../shared-styles/inputFieldConstants.css.js";
import { labelStyle } from "../shared-styles/labelStyles.css.js";
import { prefixStyle, suffixStyle } from "../shared-styles/suffixPrefix.css.js";
import { useInputFieldLogic, getInputFieldProps, isClickableIcon } from "../shared.js";
const TextField = forwardRef(function TextField2(props, ref) {
  var _a, _b, _c, _d;
  const { wrapperProps, contentProps, commonInputProps } = useInputFieldLogic(props);
  const { inputProps } = getInputFieldProps(props);
  const isModeCurrencyOrNumberFormatting = ((_a = props.mode) == null ? void 0 : _a.style) === "currency" || ((_b = props.mode) == null ? void 0 : _b.style) === "numberSpacing";
  const onChangeHandler = (event) => {
    var _a2;
    if (isModeCurrencyOrNumberFormatting) {
      event.target.value = event.target.value.replace(new RegExp("(?<!^)-|[^\\d\\W.,]+|[.,]|\\s+", "g"), "");
    }
    (_a2 = inputProps.onChange) == null ? void 0 : _a2.call(inputProps, event);
  };
  if (isModeCurrencyOrNumberFormatting && !!inputProps.value) {
    inputProps.type = "text";
    inputProps.inputMode = "numeric";
    const number = inputProps.value;
    const isNegativeNumber = number[0] === "-";
    inputProps.value = isNegativeNumber ? inputProps.value.slice(1) : inputProps.value;
    const numberPrefix = isNegativeNumber ? "-" : "";
    const formattedValue = new Intl.NumberFormat("nb-NB", {
      style: "currency",
      currency: "NOK",
      minimumFractionDigits: 0,
      maximumFractionDigits: 5
    }).format(parseFloat(inputProps.value)).replaceAll(/[^0-9.,\W]/g, "").trim();
    inputProps.value = numberPrefix + formattedValue;
  }
  return jsxs("span", { ref, className: classNames(wrapperProps.className, wrapperStyle), children: [props.leadingIcon && isClickableIcon(props.leadingIcon) && jsx("button", { className: iconButtonOverlayRecipe({
    placement: "left",
    density: wrapperProps.density
  }), title: props.leadingIcon.title, onClick: props.leadingIcon.onClick }), jsxs("label", { htmlFor: props.id, className: inputFieldWrapperRecipe({
    disabled: props.disabled,
    density: props.density,
    validityType: (_c = props.validity) == null ? void 0 : _c.type
  }), children: [jsx("input", { ...commonInputProps, ...inputProps, value: inputProps.value, onChange: onChangeHandler, className: classNames(inputFieldStyle, inputProps.className), style: assignInlineVars({
    [preInputWidth]: wrapperProps.preInputWidth,
    [postInputWidth]: wrapperProps.postInputWidth
  }), onFocus: (event) => {
    var _a2, _b2;
    if ((_a2 = event.target.value) == null ? void 0 : _a2.length) {
      window.requestAnimationFrame(() => event.target.select());
    }
    (_b2 = inputProps.onFocus) == null ? void 0 : _b2.call(inputProps, event);
  } }), jsxs("span", { className: inputContentWrapper({ density: props.density }), children: [props.leadingIcon && jsx(Icon, { icon: isClickableIcon(props.leadingIcon) ? props.leadingIcon.icon : props.leadingIcon, className: atoms({ paddingRight: "xxs" }) }), props.prefix && jsx("span", { ref: contentProps.prefixRef, "aria-hidden": true, className: prefixStyle, children: props.prefix }), jsx("label", { id: contentProps.labelId, className: labelStyle({
    density: props.density,
    validityType: (_d = props.validity) == null ? void 0 : _d.type,
    isElevated: !!props.value || props.type === "date" || props.type === "time",
    disabled: props.disabled
  }), style: {
    ...assignInlineVars({
      [preInputWidth]: wrapperProps.preInputWidth
    })
  }, children: jsx("span", { style: { position: "relative" }, children: props.label }) }), jsx("span", { style: { flexGrow: "1" } }), props.suffix && jsx("span", { ref: contentProps.suffixRef, "aria-hidden": true, className: suffixStyle, children: props.suffix }), props.trailingIcon && jsx(Icon, { icon: isClickableIcon(props.trailingIcon) ? props.trailingIcon.icon : props.trailingIcon, className: atoms({ paddingLeft: "xxs" }) })] })] }), props.trailingIcon && isClickableIcon(props.trailingIcon) && jsx("button", { className: iconButtonOverlayRecipe({
    placement: "right",
    density: wrapperProps.density
  }), title: props.trailingIcon.title, onClick: props.trailingIcon.onClick, type: "button" }), jsx(InputHelperText, { id: contentProps.helperId, validity: props.validity, helperText: props.helperText, reserveSpaceForMessage: props.reserveSpaceForMessage, disabled: props.disabled })] });
});
export {
  TextField
};
